export default {
  contactContent: {
    address: "Address",
    phone: "Phone Number",
    email: "Email Address",

    addressText:
      "16/A, Romadan House City Tower \nNew York, United States",

    formTitle: "Send Supplier Request",

    name: "Your Name",
    emailPlaceholder: "Email Address",
    phonePlaceholder: "Phone Number",
    subject: "Subject",
    message: "Start Chat",

    submit: "Raise Inquiry",
  },
};